<template>
  <el-cascader
    ref="cascader"
    :value="value"
    :options="options"
    :disabled="disabled"
    :props="{multiple:true}"
    filterable
    clearable
    :placeholder="value.length > 0 || isEdit ? ' ' : placeholder"
    class="office-department-cascader"
    no="casCaDer"
    @input="val=>{$emit('input',val)}"
    @visible-change="onVisibleChange"
  />
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'

export default {
  name: 'OfficeDepartmentCascader',
  props: {
    value: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    placeholder: { type: String, default: ' ' }
  },
  data() {
    return {
      options: [],
      isEdit: false // 是否正在编辑
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  watch: {
    value() {
      this.toCustomDisplay()
    }
  },
  created() {
    const offices = getCacheListByKey(TYPE_NAMES.basic_data_Office_All)
    const departments = getCacheListByKey(TYPE_NAMES.basic_data_Department)

    /* 按照分公司分组 */
    const officeDepMap = new Map()
    for (const item of departments) {
      let arr = officeDepMap.get(item.officeUuid)
      if (!arr) {
        arr = []
        officeDepMap.set(item.officeUuid, arr)
      }
      arr.push(item)
    }

    for (const [officeUuid, deps] of officeDepMap.entries()) {
      const office = offices.find(p => p.uuid === officeUuid)
      if (office) {
        this.options.push({
          value: officeUuid,
          label: this.isZh ? office.chineseName : office.englishName,
          children: this.buildTreeDepartments(deps)
        })
      }
    }
  },
  mounted() {
    this.toCustomDisplay(false)
  },
  methods: {
    buildTreeDepartments(deps) {
      const rootNodes = []
      const depChildMap = new Map()
      for (const item of deps) {
        if (item.parentDepartmentUuid) {
          let childs = depChildMap.get(item.parentDepartmentUuid)
          if (!childs) {
            childs = []
            depChildMap.set(item.parentDepartmentUuid, childs)
          }
          childs.push({
            value: item.departmentId,
            label: this.isZh ? item.chineseName : item.englishName
          })
        } else {
          rootNodes.push(item)
        }
      }
      const result = []
      for (const node of rootNodes) {
        const obj = {
          value: node.departmentId,
          label: this.isZh ? node.chineseName : node.englishName
        }
        const childs = depChildMap.get(node.uuid)
        if (childs) {
          obj.children = childs
        }
        result.push(obj)
      }
      return result
    },
    toCustomDisplay() {
      this.$nextTick(() => {
        const cascader = this.$refs.cascader
        if (!cascader) {
          return
        }
        const tags = cascader.$el.querySelector('.el-cascader__tags')
        if (!tags || !tags.childNodes || tags.childNodes.length === 0) {
          return
        }
        let customDisplay = null
        let searchInput = null
        for (const child of tags.childNodes) {
          if (child.classList.contains('custom-display')) {
            customDisplay = child
          } else if (child.classList.contains('el-cascader__search-input')) {
            searchInput = child
          }
        }
        if (!customDisplay) {
          customDisplay = document.createElement('span')
          customDisplay.className = 'custom-display'
          tags.insertBefore(customDisplay, tags.childNodes[0])
        }
        if (this.isEdit) {
          customDisplay.style.display = 'none'
          if (cascader.inputValue) {
            cascader.inputValue = cascader.inputValue.trim()
          }
          if (cascader.presentText) {
            cascader.presentText = cascader.presentText.trim()
          }
          if (searchInput) {
            searchInput.style.display = ''
            if (searchInput.value) {
              searchInput.value = searchInput.value.trim()
            }
            searchInput.setAttribute('placeholder', this.getDisplay() || this.placeholder)
          }
        } else {
          customDisplay.style.display = ''
          customDisplay.innerText = this.getDisplay()
          customDisplay.setAttribute('title', customDisplay.innerText)
          if (searchInput) {
            searchInput.style.display = 'none'
          }
        }
      })
    },
    getDisplay() {
      const set = new Set()
      for (const arr of this.value) {
        let option = this.options.find(p => p.value === arr[0])
        if (!option) {
          continue
        }
        for (let i = 1; i < arr.length; ++i) {
          if (!option.children) {
            break
          }
          option = option.children.find(p => p.value === arr[i])
          if (!option) {
            break
          }
          set.add(option.label)
        }
      }
      return [...set].join(',')
    },
    onVisibleChange(e) {
      this.isEdit = e
      this.toCustomDisplay()
    }
  }
}
</script>

<style lang="scss">
.el-cascader.office-department-cascader {
  width: 100%;
  .el-cascader__tags {
    .custom-display {
      overflow: hidden;
      white-space: nowrap;
      padding-left: 9px;
    }
    .el-tag--info {
      display: none;
    }
    .el-cascader__search-input {
      margin-left: 9px;
    }
  }
}
</style>
